import { SectionWrapper as Wrapper } from "pages/Product/styled";
import styled from "styled-components/macro";
import { mediaMin } from "styles/media";

export const FeatureSectionWrapper = styled(Wrapper)`
  padding: 100px 26px;
  margin: 0 auto;

  ${mediaMin.xs`
    padding: 60px 26px;
    margin: 0 auto;
  `};

  ${mediaMin.md`
    padding: 120px 26px;
    max-width: 944px;
  `};

  ${mediaMin.lg`
    padding: 120px 0;
    max-width: 1154px;
  `};
`;
